import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const C1FormControlLabelStyles: moduleStyleType = {
    root: {
        marginLeft: '1px',
        display: 'flex',
        justifyContent: 'flex-start',
    },
}
